import { observable, action, makeObservable, runInAction } from 'mobx';
import {
    getTenantList,
    getUserInfo,
    outLogin,
    tenantSort,
    tenantInfo,
    gatewayTypeReq,
    myAgentListReq,
    getIdentityInfo,
    checkToken,
    thirdConfig,
    getLoginAndOutGoPath,
    getSpecialPortal
} from '@/api/Login/login';
import { getHomeConfig } from '@/api/gateway';
import utils from '@/utils';
import message from '@/components/Toast';
import { RequestResult } from '@/api/requestType';
import { userInfoType } from './type';
import { Storage } from '@/utils/Storage';
import { needlessLoginUrl } from '@/utils/constants';
const { clearCookie } = utils;
import competition from '../competition';
import { competition_constants } from '@/utils/constants';

const defaultUserInfo: userInfoType = {
    id: '',
    name: '',
    nick_name: '',
    mobile: '',
    user_type: [], //0 无身份, 1,学员 2,学习公社平台管理员、3 租户超级管理员、4 组织超级管理员、5 普通管理员、
    avatar: ''
};

class Login {
    constructor() {
        makeObservable(this);
    }

    @observable switchTenant = false;

    @action
    setSwitchTenant = (v) => {
        this.switchTenant = v;
    };

    @observable
    showTenantList = [{ tenant_name: '' }];

    @action
    setShowTenantList = (v) => {
        this.showTenantList = v;
    };

    @observable activeIdentity = 'student'; //admin

    @action
    setActiveIdentity = (v) => {
        this.activeIdentity = v;
        if (v === 'admin') {
            this.showTenantList = this.tenantList?.adminTenants || [];
        } else {
            this.showTenantList = this.tenantList?.studentTenants || [];
        }
    };

    @observable
    tenantList = { adminTenants: [{ tenant_name: '' }], studentTenants: [{ tenant_name: '' }] };

    fetchList = async () => {
        const { data, code, msg } = await getTenantList();

        if (code === '00000') {
            runInAction(() => {
                this.tenantList = data;
                this.showTenantList = this.activeIdentity === 'admin' ? data.adminTenants : data.studentTenants;
            });
        } else {
            return message.error(msg);
        }
    };

    @observable userInfo: userInfoType = defaultUserInfo;

    outLogin = async (login_url) => {
        const { code, msg } = await outLogin();
        let { logout_config = {} } = this.loginAndOutConfig,
            { logout_redirect_type = 0, can_logout = 0 } = logout_config,
            url = `https://${window.location.host}/login`;
        clearCookie(window.location.host);
        if (code === '00000') {
            Storage.remove('userInfo');
            if (logout_redirect_type === 1 && can_logout === 1) {
                //开启退出登录&&自定义退出登录页
                url = this?.loginAndOutConfig?.logout_config?.pc;
                window.location.href = login_url ? login_url : url;
                return false;
            }
            runInAction(() => {
                this.userInfo = defaultUserInfo;
            });
            return true;
        }
        message.error(msg);
        return false;
    };

    @observable tenantInfo = { name: '' };
    //租户信息
    getTenantInfo = async () => {
        let isHaveId = false;
        const res: RequestResult = await tenantInfo();

        if (res.code === '00000') {
            Storage.set('TENANT_KEY', res.data.id);
            Storage.set('tenantName', res.data.name);
            // document.title = res.data?.name || '学习公社';
            runInAction(() => {
                this.tenantInfo = res.data;
            });
            isHaveId = true;
        } else {
            isHaveId = false;
            message.error(res.msg);
        }
        return isHaveId;
    };
    @observable
    agentList = [];
    @action
    setAgentList = (data) => {
        this.agentList = data;
    };

    @observable gatewayType = 0; //门户类型 0普通1智能体

    @observable scope_type = 1; //1不限制2租户内学员3指定范围

    getGatewayType = async (portal_id) => {
        if (!portal_id) {
            return;
        }
        const res: RequestResult = await gatewayTypeReq({ portal_id });
        if (res.code === '00000') {
            runInAction(() => {
                this.gatewayType = res.data?.gateway_type;
                this.scope_type = res.data?.scope_type;
            });
            const isLogin = await this.checkLogin();
            if (res.data?.gateway_type === 1 && isLogin) {
                const agentListRes = await myAgentListReq();
                if (agentListRes.success) this.setAgentList(agentListRes.data || []);
            }
        } else {
            runInAction(() => {
                this.gatewayType = 0;
                this.scope_type = 1;
            });
        }
    };

    @observable
    isLogin = false;

    @action
    setIsLogin = (v) => {
        this.isLogin = v;
    };
    @observable navigate = null;
    @action
    setNavigate = (navigate) => {
        this.navigate = navigate;
    };
    @observable
    loginAndOutConfig: any = {
        logout_config: {
            can_logout: 1,
            logout_redirect_type: 0
        }
    }; //登录退出配置
    //获取登录和退出配置，判断登录和退出成功后跳到哪里
    getLoginAndOutConfig = async () => {
        let res = await getLoginAndOutGoPath();
        if (res && res.code === '00000') {
            runInAction(() => {
                if (res.data && Object.keys(res.data).length) {
                    this.loginAndOutConfig = res.data;
                } else {
                    this.loginAndOutConfig = {
                        logout_config: {
                            can_logout: 1,
                            logout_redirect_type: 0
                        }
                    };
                }
            });
            return res.data;
        }
        message.error(res.msg || '');
        return false;
    };
    @observable
    specialPortalConfig: any = {}; //登录退出配置
    //获取专属门户配置---判断登录页地址
    getSpecialPortal = async () => {
        let portal_id = Storage.get('portal_id'),
            res = await getSpecialPortal(portal_id).catch((err) => {
                console.log(err);
                return false;
            });
        if (res && res.code === '00000') {
            runInAction(() => {
                if (res.data) {
                    this.specialPortalConfig = res.data;
                } else {
                    this.specialPortalConfig = null;
                }
            });
            return res.data;
        }
        return false;
        // return message.error(res.msg || '');
    };
    goLogin = async () => {
        let res: any = await this.getSpecialPortal();
        console.log(res);

        if (res?.pc) {
            window.location.href = res?.pc;
        } else {
            window.location.href = `${window.location.protocol}//${window.location.host}/login?redirect=${window.location.href}`;
        }
    };
    checkLogin = async () => {
        const { data } = await checkToken();
        return data;
    };
    getUserInfo = async () => {
        const res: RequestResult = await getUserInfo();

        if (res.code === '00000') {
            if (res.data) {
                Storage.set('userInfo', JSON.stringify(res.data));
                this.getLoginAndOutConfig();
                runInAction(() => {
                    this.userInfo = res.data || {};
                });
            } else {
                Storage.remove('userInfo');
            }
        } else {
            return message.error(res.msg);
        }
        return res;
    };

    tenantSort = async (params) => {
        const { code, msg } = await tenantSort(params);

        if (code === '00000') {
            this.fetchList();
        } else {
            return message.error(msg);
        }
    };

    // 头部配置 logo 字体颜色 背景透明度
    @observable
    pageHeaderConfig = { image_path: '', theme: 1 };
    @observable
    pageImageConfig = { image_path: '', height: '', display: '', filling_mode: '' };

    getPageHeader = async () => {
        let headerPage = this.allHomePage.filter((ele) => ele.types === 6);
        if (headerPage && headerPage.length) {
            const obj = headerPage.find((v) => v.alias === 'pagehead')?.page_config || '',
                imageObj = headerPage.find((v) => v.alias === 'headimage')?.page_config || '';
            if (obj) {
                this.pageHeaderConfig = JSON.parse(obj);
            }
            if (imageObj) {
                this.pageImageConfig = JSON.parse(imageObj);
            }
        }
    };

    // 顶部导航配置
    @observable
    headerRoutes = [];

    getHeaderRoutes = async () => {
        let temData = this.allHomePage.filter((ele) => ele.types === 5);
        if (temData && temData.length) {
            // 根据 ordinal 字段对 temData 进行升序排序
            temData.sort((a, b) => (a.ordinal || 0) - (b.ordinal || 0));
            this.headerRoutes = temData;
            this.getHomeConfig();
        }
    };

    // 个人中心导航配置
    @observable
    userCenterRoutes = [];

    getUserCenterRoutes = async () => {
        let useCenterHomePage = this.allHomePage.filter((ele) => ele.types === 2);
        if (useCenterHomePage && useCenterHomePage.length) {
            this.userCenterRoutes = useCenterHomePage;
        }
    };

    //处理门户信息
    handlePortalInfo = (data) => {
        if (data.length) {
            let portal_name: any = data[0]?.portal_name;
            if (portal_name) {
                document.title = portal_name;
            } else {
                document.title = Storage.get('tenantName') as string;
            }
        }
    };
    //所有的路由
    @observable
    allHomePage: any = [];
    getAllHomePage = async () => {
        const portal_id = localStorage.getItem('portal_id') || '',
            res = await getHomeConfig({ used_type: 1, portal_id });
        if (res?.code === '00000') {
            if (res.data.length) {
                this.allHomePage = res.data;
                localStorage.setItem('portal_id', res.data[0]?.portal_id);
                this.handlePortalInfo(res.data);
                await this.getGatewayType(res.data[0]?.portal_id);
            }
        } else if (res?.code === 'A1119') {
            await this.getGatewayType(portal_id);
            if (!window.location.pathname.includes('no-auth')) {
                if (needlessLoginUrl.some((url) => window.location.pathname.includes(url)) && this.scope_type === 1) {
                    //业务不需要登录的页面
                    window.location.href = `/web/no-auth?redirect=${encodeURIComponent(window.location.href)}`;
                } else if (
                    (window.location.pathname === '/web/' || window.location.pathname === '/web/home' || window.location.pathname === '/web') &&
                    this.scope_type === 1
                ) {
                    //首页-门户
                    window.location.href = `/web/no-auth?redirect=${encodeURIComponent(`${window.location.origin}${window.location.pathname}`)}`;
                } else {
                    window.location.href = '/web/no-auth';
                }
            }
        } else if (res?.code === 'A1120') {
            //跳转登录
            if (!window.location.pathname.includes('no-auth') && !window.location.pathname.includes('login')) {
                window.location.href = `/login?redirect=${window.location.href}`;
            }
        }
    };
    //开心学堂路由
    @observable
    studyRoutes = [];
    getStudyRoutes = async () => {
        let studyPage = this.allHomePage.filter((ele) => ele.types === 7);
        if (studyPage && studyPage.length) {
            this.studyRoutes = studyPage;
        }
    };
    // 首页低代码链接
    @observable
    pageHomeConfig = {};

    getHomeConfig = async () => {
        let temData = this.allHomePage.filter((ele) => ele.types === 1);
        if (temData && temData.length) {
            this.pageHomeConfig = temData[0] || {};
        }
    };

    //大赛需求新增逻辑 start

    @observable current_user_type = 0; //1：学员 2：评审员 3：参赛人管理员 4:大赛内中小学学员 5:赛事管理员 6:大赛内幼儿园教师学员  7: 参加大赛非赛程人员-中小学 8：参加大赛非赛程人员-幼儿园

    @action
    setCurrentUserType = (v) => {
        this.current_user_type = v;
    };

    @observable identityInfo = {};

    getIdentityInfo = async (params) => {
        const {
            data: { code, msg, data }
        } = await getIdentityInfo(params);
        if (code === '00000') {
            const plan_name = data.plan_name?.split('-')[0] || '';
            if (this.qhbMode === 'city') {
                if (data.user_type.indexOf(4) !== -1 && /幼儿园教师/.test(plan_name)) {
                    data.user_type.splice(data.user_type.indexOf(4), 1, 6);
                }
                if (data.user_type.indexOf(7) !== -1 && /幼儿园教师/.test(plan_name)) {
                    data.user_type.splice(data.user_type.indexOf(7), 1, 8);
                }
            } else {
                if (data.user_type.indexOf(4) !== -1) {
                    data.user_type.splice(data.user_type.indexOf(4), 1, 6);
                }
                if (data.user_type.indexOf(7) !== -1) {
                    data.user_type.splice(data.user_type.indexOf(7), 1, 8);
                }
            }
            //如果是参赛人 查问卷
            if (
                data.user_type.indexOf(4) !== -1 ||
                data.user_type.indexOf(6) !== -1 ||
                data.user_type.indexOf(7) !== -1 ||
                data.user_type.indexOf(8) !== -1
            ) {
                await competition.getQuestionInfo({
                    business_id: competition.business_id,
                    template_id: competition_constants.template_id,
                    plan_id: data.plan_id
                });
            }

            if (!(data.user_type?.length === 1 && data.user_type[0] === 1)) {
                data.user_type = data.user_type.filter((e) => {
                    return e !== 1;
                });
            }
            runInAction(() => {
                this.current_user_type = data.user_type[0];
                this.identityInfo = Object.assign({}, data, { plan_name });
            });
        } else if (code === 'A0128') {
            window.location.href = `${params?.login_url}?redirect=${window.location.href}`;
        } else {
            runInAction(() => {
                this.identityInfo = {};
                this.current_user_type = 0;
            });
            return message.error(msg);
        }
    };

    @observable qhbMode = 'city'; //region

    @action
    setQhbMode = (v) => {
        this.qhbMode = v;
    };

    //大赛需求新增逻辑 end

    // 第三方配置
    @observable
    thirdConfig = {};

    getThirdConfig = async () => {
        const { code, msg, data } = await thirdConfig();
        if (code === '00000') {
            runInAction(() => {
                if (data) {
                    this.thirdConfig = data;
                } else {
                    this.thirdConfig = {
                        forbid_quit: false,
                        login_redirect: 1
                    };
                }
            });
        } else {
            return message.error(msg);
        }
    };
}

export default new Login();
